module.exports = __webpack_public_path__ + "static/img/1958_08_23_Boston_AnticMeetReview.fd838a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_08_23_Boston_AnticMeetReview.jpg
// module id = 8ooC
// module chunks = 0